import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./booking.css";

const Booking = () => {
  const location = useLocation();

const { tourId: stateTourId, tourTitle, pricings,endDate: durationDays } = location.state || {};

const [step, setStep] = useState(1);
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState(false);
const navigate = useNavigate();
const [confirmPopup, setConfirmPopup] = useState(false); // لفتح الـ confirmation popup

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneCode: "",
    phoneNumber: "",
    startDate: "",
    endDate: "",
    adults: 1,
    children: 0,
    notes: "",
  });

const [computedEndDate, setComputedEndDate] = useState("");


useEffect(() => {
if (formData.startDate && durationDays) {
const start = new Date(formData.startDate);
const end = new Date(start);
end.setDate(end.getDate() + durationDays); // الرحلة يوم واحد يعني +1
setComputedEndDate(end.toISOString().split("T")[0]);
}
}, [formData.startDate, durationDays]);

const minStartDate = new Date();
minStartDate.setDate(minStartDate.getDate() + 2);
const minDateStr = minStartDate.toISOString().split("T")[0];

const { id: paramId } = useParams();

const tourId = stateTourId || paramId; // fallback لو state فاضية

  const [totalPrice, setTotalPrice] = useState(0);

  // 🧮 حساب السعر بالمنطق الصحيح
  const calculatePrice = (adults, children) => {
    const totalPersons = adults + children;
    if (!pricings || pricings.length === 0) return 0;

    // 1️⃣ لو العدد يقع داخل Range صحيح
    let exact = pricings.find(
      (p) => totalPersons >= p.min_persons && totalPersons <= p.max_persons
    );

    if (exact) {
      return (
        adults * parseFloat(exact.price_per_person) +
        children * parseFloat(exact.children_price || 0)
      );
    }

    // ترتيب الشرائح
    const sorted = [...pricings].sort((a, b) => a.min_persons - b.min_persons);

    // 2️⃣ لو أقل من أقل شريحة → استخدم أول شريحة
    if (totalPersons < sorted[0].min_persons) {
      const p = sorted[0];
      return (
        adults * parseFloat(p.price_per_person) +
        children * parseFloat(p.children_price || 0)
      );
    }

    // 3️⃣ لو أكبر من أكبر شريحة → استخدم آخر شريحة
    if (totalPersons > sorted[sorted.length - 1].max_persons) {
      const p = sorted[sorted.length - 1];
      return (
        adults * parseFloat(p.price_per_person) +
        children * parseFloat(p.children_price || 0)
      );
    }

    // 4️⃣ لو بين شريحتين → هات أقرب شريحة للعدد
    let closest = sorted.reduce((prev, curr) => {
      const prevDiff = Math.abs(totalPersons - prev.max_persons);
      const currDiff = Math.abs(totalPersons - curr.max_persons);
      return currDiff < prevDiff ? curr : prev;
    });

    return (
      adults * parseFloat(closest.price_per_person) +
      children * parseFloat(closest.children_price || 0)
    );
  };

  const handleNextStep = () => {
    const price = calculatePrice(formData.adults, formData.children);
    setTotalPrice(price);
    setStep(2);
  };
useEffect(() => {
  setTotalPrice(calculatePrice(formData.adults, formData.children));
}, [formData.adults, formData.children]);

const sendRequest = async () => {
  try {
    setLoading(true);

    const price = calculatePrice(formData.adults, formData.children);

    const payload = {
      tour_id: tourId,
      tour_title: tourTitle,
      fullName: formData.fullName,
      email: formData.email,
      phoneCode: formData.phoneCode,
      phoneNumber: formData.phoneNumber,
      startDate: formData.startDate,
      endDate: computedEndDate,
      adults: Number(formData.adults),
      children: Number(formData.children),
      notes: formData.notes,
      total_price: price,
    };

    const response = await fetch(
      "https://orangered-hornet-549881.hostingersite.com/api/bookingsTour",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    setLoading(false);

    if (!response.ok) {
      alert("Something went wrong! " + (data.message || ""));
      return;
    }

    // بعد النجاح ارجع للصفحة الرئيسية
    navigate("/");
  } catch (error) {
    setLoading(false);
    console.error(error);
    alert("Network error!");
  }
};

const handleSendRequest = async () => {
  try {
    setLoading(true); // ✅ بداية اللودينج

    const price = calculatePrice(formData.adults, formData.children);

   const payload = {
tour_id: tourId,
tour_title: tourTitle,
fullName: formData.fullName,
email: formData.email,
phoneCode: formData.phoneCode,
phoneNumber: formData.phoneNumber,
startDate: formData.startDate,
endDate: computedEndDate, // هنا End Date محسوب تلقائي
adults: Number(formData.adults),
children: Number(formData.children),
notes: formData.notes,
total_price: totalPrice,
};


    const response = await fetch(
      "https://orangered-hornet-549881.hostingersite.com/api/bookingsTour",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    setLoading(false); // ✅ نهاية اللودينج

    if (!response.ok) {
      alert("Something went wrong! " + (data.message || ""));
      return;
    }

    // ✅ إظهار popup النجاح
    setSuccess(true);

    // ✅ بعد ثانيتين نروح للصفحة الرئيسية
    setTimeout(() => {
      navigate("/"); // الرابط للصفحة الرئيسية
    }, 2000);

  } catch (error) {
    setLoading(false);
    console.error(error);
    alert("Network error!");
  }
};



  // تحديث بيانات الفورم
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    
    <div className="booking-wrapper">
    
{confirmPopup && !loading && (
  <div className="popup-overlay">
    <div className="popup-box">
      <h3>Confirm Your Booking</h3>
      <div className="popup-content">
        <table className="popup-table">
          <tbody>
            <tr><th>Name</th><td>{formData.fullName}</td></tr>
            <tr><th>Email</th><td>{formData.email}</td></tr>
            <tr><th>Phone</th><td>{formData.phoneCode} {formData.phoneNumber}</td></tr>
            <tr><th>Date</th><td>{formData.startDate} to {computedEndDate}</td></tr>
            <tr><th>Adults</th><td>{formData.adults}</td></tr>
            <tr><th>Children</th><td>{formData.children}</td></tr>
            <tr><th>Notes</th><td>{formData.notes || "None"}</td></tr>
            <tr><th>Total Price</th><td>${totalPrice.toFixed(2)}</td></tr>
          </tbody>
        </table>
      </div>
      <div className="popup-actions">
        <button className="btn-cancel" onClick={() => setConfirmPopup(false)}>Cancel</button>
        <button className="btn-send" onClick={sendRequest}>Send</button>
      </div>
    </div>
  </div>
)}

{loading && (
  <div className="loading-overlay">
    <div className="spinner"></div>
  </div>
)}

{success && (
  <div className="popup-success">
    <p>Booking sent successfully! ✅</p>
  </div>
)}
      {step === 1 ? (
        <section className="booking-form">
          <h2 className="form-title">Booking Information</h2>
          <form className="grid gap-4">
            {/* Name & Email */}
            <div className="grid md:grid-cols-2 gap-4">
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Full Name*"
                required
                className="form-input-booking modern-booking"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email*"
                required
                className="form-input-booking modern-booking"
              />
            </div>

            {/* Phone */}
            <div className="grid md:grid-cols-2 gap-4">
            <select
  name="phoneCode"
  value={formData.phoneCode}
  onChange={handleChange}
  className="form-input-booking modern-booking"
>
  <option value="">Phone code</option>
  <option value="+1">United States (+1)</option>
  <option value="+7">Russia (+7)</option>
  <option value="+20">Egypt (+20)</option>
  <option value="+27">South Africa (+27)</option>
  <option value="+30">Greece (+30)</option>
  <option value="+31">Netherlands (+31)</option>
  <option value="+32">Belgium (+32)</option>
  <option value="+33">France (+33)</option>
  <option value="+34">Spain (+34)</option>
  <option value="+36">Hungary (+36)</option>
  <option value="+39">Italy (+39)</option>
  <option value="+40">Romania (+40)</option>
  <option value="+41">Switzerland (+41)</option>
  <option value="+43">Austria (+43)</option>
  <option value="+44">United Kingdom (+44)</option>
  <option value="+45">Denmark (+45)</option>
  <option value="+46">Sweden (+46)</option>
  <option value="+47">Norway (+47)</option>
  <option value="+48">Poland (+48)</option>
  <option value="+49">Germany (+49)</option>
  <option value="+51">Peru (+51)</option>
  <option value="+52">Mexico (+52)</option>
  <option value="+53">Cuba (+53)</option>
  <option value="+54">Argentina (+54)</option>
  <option value="+55">Brazil (+55)</option>
  <option value="+56">Chile (+56)</option>
  <option value="+57">Colombia (+57)</option>
  <option value="+58">Venezuela (+58)</option>
  <option value="+60">Malaysia (+60)</option>
  <option value="+61">Australia (+61)</option>
  <option value="+62">Indonesia (+62)</option>
  <option value="+63">Philippines (+63)</option>
  <option value="+64">New Zealand (+64)</option>
  <option value="+65">Singapore (+65)</option>
  <option value="+66">Thailand (+66)</option>
  <option value="+81">Japan (+81)</option>
  <option value="+82">South Korea (+82)</option>
  <option value="+84">Vietnam (+84)</option>
  <option value="+86">China (+86)</option>
  <option value="+90">Turkey (+90)</option>
  <option value="+91">India (+91)</option>
  <option value="+92">Pakistan (+92)</option>
  <option value="+93">Afghanistan (+93)</option>
  <option value="+94">Sri Lanka (+94)</option>
  <option value="+95">Myanmar (+95)</option>
  <option value="+98">Iran (+98)</option>
  <option value="+212">Morocco (+212)</option>
  <option value="+213">Algeria (+213)</option>
  <option value="+216">Tunisia (+216)</option>
  <option value="+218">Libya (+218)</option>
  <option value="+220">Gambia (+220)</option>
  <option value="+221">Senegal (+221)</option>
  <option value="+222">Mauritania (+222)</option>
  <option value="+223">Mali (+223)</option>
  <option value="+224">Guinea (+224)</option>
  <option value="+225">Ivory Coast (+225)</option>
  <option value="+226">Burkina Faso (+226)</option>
  <option value="+227">Niger (+227)</option>
  <option value="+228">Togo (+228)</option>
  <option value="+229">Benin (+229)</option>
  <option value="+230">Mauritius (+230)</option>
  <option value="+231">Liberia (+231)</option>
  <option value="+232">Sierra Leone (+232)</option>
  <option value="+233">Ghana (+233)</option>
  <option value="+234">Nigeria (+234)</option>
  <option value="+235">Chad (+235)</option>
  <option value="+236">Central African Republic (+236)</option>
  <option value="+237">Cameroon (+237)</option>
  <option value="+238">Cape Verde (+238)</option>
  <option value="+239">Sao Tome & Principe (+239)</option>
  <option value="+240">Equatorial Guinea (+240)</option>
  <option value="+241">Gabon (+241)</option>
  <option value="+242">Congo (+242)</option>
  <option value="+243">DR Congo (+243)</option>
  <option value="+244">Angola (+244)</option>
  <option value="+245">Guinea-Bissau (+245)</option>
  <option value="+246">British Indian Ocean Territory (+246)</option>
  <option value="+247">Ascension (+247)</option>
  <option value="+248">Seychelles (+248)</option>
  <option value="+249">Sudan (+249)</option>
  <option value="+250">Rwanda (+250)</option>
  <option value="+251">Ethiopia (+251)</option>
  <option value="+252">Somalia (+252)</option>
  <option value="+253">Djibouti (+253)</option>
  <option value="+254">Kenya (+254)</option>
  <option value="+255">Tanzania (+255)</option>
  <option value="+256">Uganda (+256)</option>
  <option value="+257">Burundi (+257)</option>
  <option value="+258">Mozambique (+258)</option>
  <option value="+260">Zambia (+260)</option>
  <option value="+261">Madagascar (+261)</option>
  <option value="+262">Réunion (+262)</option>
  <option value="+263">Zimbabwe (+263)</option>
  <option value="+264">Namibia (+264)</option>
  <option value="+265">Malawi (+265)</option>
  <option value="+266">Lesotho (+266)</option>
  <option value="+267">Botswana (+267)</option>
  <option value="+268">Eswatini (+268)</option>
  <option value="+269">Comoros (+269)</option>
  <option value="+290">Saint Helena (+290)</option>
  <option value="+291">Eritrea (+291)</option>
  <option value="+297">Aruba (+297)</option>
  <option value="+298">Faroe Islands (+298)</option>
  <option value="+299">Greenland (+299)</option>
  <option value="+350">Gibraltar (+350)</option>
  <option value="+351">Portugal (+351)</option>
  <option value="+352">Luxembourg (+352)</option>
  <option value="+353">Ireland (+353)</option>
  <option value="+354">Iceland (+354)</option>
  <option value="+355">Albania (+355)</option>
  <option value="+356">Malta (+356)</option>
  <option value="+357">Cyprus (+357)</option>
  <option value="+358">Finland (+358)</option>
  <option value="+359">Bulgaria (+359)</option>
  <option value="+370">Lithuania (+370)</option>
  <option value="+371">Latvia (+371)</option>
  <option value="+372">Estonia (+372)</option>
  <option value="+373">Moldova (+373)</option>
  <option value="+374">Armenia (+374)</option>
  <option value="+375">Belarus (+375)</option>
  <option value="+376">Andorra (+376)</option>
  <option value="+377">Monaco (+377)</option>
  <option value="+378">San Marino (+378)</option>
  <option value="+379">Vatican (+379)</option>
  <option value="+380">Ukraine (+380)</option>
  <option value="+381">Serbia (+381)</option>
  <option value="+382">Montenegro (+382)</option>
  <option value="+383">Kosovo (+383)</option>
  <option value="+385">Croatia (+385)</option>
  <option value="+386">Slovenia (+386)</option>
  <option value="+387">Bosnia & Herzegovina (+387)</option>
  <option value="+389">North Macedonia (+389)</option>
  <option value="+420">Czech Republic (+420)</option>
  <option value="+421">Slovakia (+421)</option>
  <option value="+423">Liechtenstein (+423)</option>
  <option value="+500">Falkland Islands (+500)</option>
  <option value="+501">Belize (+501)</option>
  <option value="+502">Guatemala (+502)</option>
  <option value="+503">El Salvador (+503)</option>
  <option value="+504">Honduras (+504)</option>
  <option value="+505">Nicaragua (+505)</option>
  <option value="+506">Costa Rica (+506)</option>
  <option value="+507">Panama (+507)</option>
  <option value="+508">Saint Pierre & Miquelon (+508)</option>
  <option value="+509">Haiti (+509)</option>
  <option value="+590">Guadeloupe (+590)</option>
  <option value="+591">Bolivia (+591)</option>
  <option value="+592">Guyana (+592)</option>
  <option value="+593">Ecuador (+593)</option>
  <option value="+594">French Guiana (+594)</option>
  <option value="+595">Paraguay (+595)</option>
  <option value="+596">Martinique (+596)</option>
  <option value="+597">Suriname (+597)</option>
  <option value="+598">Uruguay (+598)</option>
  <option value="+599">Caribbean Netherlands (+599)</option>
  <option value="+670">Timor-Leste (+670)</option>
  <option value="+672">Australian External Territories (+672)</option>
  <option value="+673">Brunei (+673)</option>
  <option value="+674">Nauru (+674)</option>
  <option value="+675">Papua New Guinea (+675)</option>
  <option value="+676">Tonga (+676)</option>
  <option value="+677">Solomon Islands (+677)</option>
  <option value="+678">Vanuatu (+678)</option>
  <option value="+679">Fiji (+679)</option>
  <option value="+680">Palau (+680)</option>
  <option value="+681">Wallis & Futuna (+681)</option>
  <option value="+682">Cook Islands (+682)</option>
  <option value="+683">Niue (+683)</option>
  <option value="+685">Samoa (+685)</option>
  <option value="+686">Kiribati (+686)</option>
  <option value="+687">New Caledonia (+687)</option>
  <option value="+688">Tuvalu (+688)</option>
  <option value="+689">French Polynesia (+689)</option>
  <option value="+690">Tokelau (+690)</option>
  <option value="+691">Micronesia (+691)</option>
  <option value="+692">Marshall Islands (+692)</option>
  <option value="+850">North Korea (+850)</option>
  <option value="+852">Hong Kong (+852)</option>
  <option value="+853">Macau (+853)</option>
  <option value="+855">Cambodia (+855)</option>
  <option value="+856">Laos (+856)</option>
  <option value="+870">Inmarsat (+870)</option>
  <option value="+880">Bangladesh (+880)</option>
  <option value="+886">Taiwan (+886)</option>
  <option value="+960">Maldives (+960)</option>
  <option value="+961">Lebanon (+961)</option>
  <option value="+962">Jordan (+962)</option>
  <option value="+963">Syria (+963)</option>
  <option value="+964">Iraq (+964)</option>
  <option value="+965">Kuwait (+965)</option>
  <option value="+966">Saudi Arabia (+966)</option>
  <option value="+967">Yemen (+967)</option>
  <option value="+968">Oman (+968)</option>
  <option value="+971">United Arab Emirates (+971)</option>
  <option value="+972">Israel (+972)</option>
  <option value="+973">Bahrain (+973)</option>
  <option value="+974">Qatar (+974)</option>
  <option value="+975">Bhutan (+975)</option>
  <option value="+976">Mongolia (+976)</option>
  <option value="+977">Nepal (+977)</option>
  <option value="+992">Tajikistan (+992)</option>
  <option value="+993">Turkmenistan (+993)</option>
  <option value="+994">Azerbaijan (+994)</option>
  <option value="+995">Georgia (+995)</option>
  <option value="+996">Kyrgyzstan (+996)</option>
  <option value="+998">Uzbekistan (+998)</option>
</select>

              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Phone Number*"
                className="form-input-booking modern-booking"
              />
            </div>

     

  {/* Dates */}
<div className="grid md:grid-cols-2 gap-4">
  <div className="date-input-wrapper">
    <label htmlFor="startDate" className="date-label">Start Date</label>
    <input type="date" id="startDate" name="startDate" value={formData.startDate} onChange={handleChange} className="form-input-booking modern-booking" min={minDateStr} required />
  </div>
  <div className="date-input-wrapper">
    <label htmlFor="endDate" className="date-label">End Date</label>
    <input type="text" value={computedEndDate} readOnly className="form-input-booking modern-booking" />
  </div>
</div>
           {/* Guests with counters */}
<div className="grid md:grid-cols-2 gap-4">
  {/* Adults counter */}
  <div className="counter-box-booking">
    <span>Adults</span>
    <div className="counter-controls">
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({
            ...prev,
            adults: prev.adults > 1 ? prev.adults - 1 : 1,
          }))
        }
      >
        -
      </button>
      <span>{formData.adults}</span>
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({ ...prev, adults: prev.adults + 1 }))
        }
      >
        +
      </button>
    </div>
  </div>

  {/* Children counter */}
  <div className="counter-box-booking">
    <span>Children</span>
    <div className="counter-controls">
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({
            ...prev,
            children: prev.children > 0 ? prev.children - 1 : 0,
          }))
        }
      >
        -
      </button>
      <span>{formData.children}</span>
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({ ...prev, children: prev.children + 1 }))
        }
      >
        +
      </button>
    </div>
  </div>
</div>
 



            {/* Note */}
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Request Note"
              className="form-input-text-area-booking modern w-full"
            ></textarea>

    <button
  type="button"
  className="submit-btn"
  onClick={() => setConfirmPopup(true)}
>
  Send Request
</button>


            
          </form>
        </section>
      ) 
      : (
        <div className="payment-card">
          <h2 className="form-title">Secure Payment</h2>
          <p className="tour-info">Tour: {tourTitle}</p>
          <p className="total-price">Total: ${totalPrice}</p>
              <form>
            <div className="form-group">
              <label>Cardholder Name</label>
              <input type="text" placeholder="John Doe" />
            </div>
            <div className="form-group">
              <label>Card Number</label>
              <input type="text" placeholder="1234 5678 9012 3456" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Expiry Date</label>
                <input type="text" placeholder="MM/YY" />
              </div>
              <div className="form-group">
                <label>CVV</label>
                <input type="password" placeholder="***" />
              </div>
            </div>
            <div className="text-center">
              <button className="submit-btn">Pay Now</button>
            </div>
          </form>

          <button className="back-btn" onClick={() => setStep(1)}>
            ← Back to Booking
          </button>
        </div>
      
      )}
    </div>
  );
};

export default Booking;


{/* <button
              type="button"
              onClick={handleNextStep}
              className="submit-btn"
            >
              Continue to Payment
            </button> */}
